import Form from 'react-bootstrap/Form';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
var conts='';
const AddTestimonial = () => {
    const urlredirect = useNavigate();
    const toast_alert = (sms, status) => {
        if (status == 0) {
            toast.success(sms, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(sms, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    const Add = (e) => {
        e.preventDefault();
        if (e.currentTarget.profile.value!='' && e.currentTarget.name.value!='' && conts!='') {
            var img = e.currentTarget.profile.files;
            const formData = new FormData();
            formData.append('image', img[0]);
            formData.append('name', e.currentTarget.name.value);
            formData.append('status', e.currentTarget.status.value);
            formData.append('Contant',conts);
            fetch(process.env.REACT_APP_API_URL+'/testimonial', {
                method: 'POST',
                body: formData
            }).then(response => response.json())
                .then(data => {
                    if (data['status'] == 'success') {
                        toast_alert('Testimonial Succussfully added.', 0);
                        urlredirect('/admin/testimonial');
                    } else {
                        toast_alert(data['status'], 1);
                    }
                }).catch((error) => {
                    toast_alert('Somthing a worng...!!', 1);
                });
        }else{
            if(e.currentTarget.profile.value==''){ toast_alert('Please select profile image...', 1); return false; }
            if(e.currentTarget.name.value==''){ toast_alert('Please enter title...', 1); return false; }
            if(conts==''){ toast_alert('Please enter content...', 1); return false; }
        }
    }
    return (<>
        <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <ToastContainer />
                        <div className='d-flex justify-content-between'>
                            <div className=''>
                                <h6 className="card-title">Testimonial</h6>
                                <p className="text-muted mb-3">Add New</p>
                            </div>
                            <Link to="/admin/testimonial"><button className='border border-success bg-success text-white'>Testimonial List</button></Link>
                        </div>
                        <div className="table-responsive pt-3">
                            <Form onSubmit={Add}>
                                <div className="mb-3">
                                    <label htmlFor="profile" className="form-label">Pic</label>
                                    <input className="form-control" type="file" id="profile" accept="image/*" />
                                </div>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control id="name" type="text" placeholder="Title" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Content</Form.Label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data=""
                                        onChange={(event, editor) => {
                                            conts = editor.getData();
                                        }}
                                    />
                                    <Form.Group className="mb-3 mt-3">
                                    <Form.Label htmlFor="status">Status</Form.Label>
                                    <Form.Select id="status">
                                        <option value={0}>Inactive</option>
                                        <option value={1}>Active</option>
                                    </Form.Select>
                                </Form.Group>
                                    <Form.Group className="mt-3" controlId="description">
                                        <input type='submit' className="btn btn-outline-primary" value="Add New" />
                                    </Form.Group>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default AddTestimonial;